'use client';

import { c as _c } from "react/compiler-runtime";
import { useConnectToDistrict } from '#@/components/hooks/useConnectToDistrict';
type FieldChangeEvent = Event & {
  currentTarget: HTMLElement & {
    value: string;
  };
};
export function ConnectButton() {
  const $ = _c(17);
  const {
    marketplaceSlug,
    marketplaceSlugError,
    isConnecting,
    changeSlug,
    connect
  } = useConnectToDistrict();
  let t0;
  if ($[0] !== marketplaceSlugError) {
    t0 = marketplaceSlugError ? {
      error: marketplaceSlugError
    } : {};
    $[0] = marketplaceSlugError;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== changeSlug) {
    t1 = event => {
      changeSlug(event.currentTarget.value);
    };
    $[2] = changeSlug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== marketplaceSlug || $[5] !== t0 || $[6] !== t1) {
    t2 = <s-text-field label="Marketplace Slug" placeholder="shop-1" value={marketplaceSlug} {...t0} onChange={t1} />;
    $[4] = marketplaceSlug;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== connect) {
    t3 = () => {
      connect();
    };
    $[8] = connect;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isConnecting || $[11] !== t3) {
    t4 = <s-button variant="primary" loading={isConnecting} disabled={isConnecting} onClick={t3}>Connect to District</s-button>;
    $[10] = isConnecting;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <s-text color="subdued">By clicking Connect, you agree to connect your Shopify store to District. This will allow District to sync your products and manage your marketplace listings.</s-text>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t4) {
    t6 = <s-stack gap="base">{t2}{t4}{t5}</s-stack>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}